import {
  doc,
  onSnapshot,
  setDoc,
  updateDoc,
  Unsubscribe
} from 'firebase/firestore';
import { db } from './firebase';
import { SiteSettings, ImpactStats } from '../types';
import { sanitizeFirestoreData } from '../utils/sanitizeFirestore';

const SETTINGS_DOC = 'settings/general';
const STATS_DOC = 'stats/impact';

export function subscribeSettings(
  onData: (settings: SiteSettings) => void,
  onError?: (error: Error) => void
): Unsubscribe {
  const docRef = doc(db, SETTINGS_DOC);
  return onSnapshot(
    docRef,
    (snapshot) => {
      if (snapshot.exists()) {
        onData(snapshot.data() as SiteSettings);
      }
    },
    (err) => {
      console.error('Error listening to site settings:', err);
      if (onError) onError(err);
    }
  );
}

export async function updateSettings(updates: Partial<SiteSettings>): Promise<void> {
  const docRef = doc(db, SETTINGS_DOC);
  await updateDoc(docRef, sanitizeFirestoreData(updates));
}

export async function setSettings(settings: SiteSettings): Promise<void> {
  const docRef = doc(db, SETTINGS_DOC);
  await setDoc(docRef, sanitizeFirestoreData(settings), { merge: true });
}

export function subscribeStats(
  onData: (stats: ImpactStats) => void,
  onError?: (error: Error) => void
): Unsubscribe {
  const docRef = doc(db, STATS_DOC);
  return onSnapshot(
    docRef,
    (snapshot) => {
      if (snapshot.exists()) {
        onData(snapshot.data() as ImpactStats);
      }
    },
    (err) => {
      console.error('Error listening to impact stats:', err);
      if (onError) onError(err);
    }
  );
}

export async function updateStats(updates: Partial<ImpactStats>): Promise<void> {
  const docRef = doc(db, STATS_DOC);
  await setDoc(docRef, sanitizeFirestoreData(updates), { merge: true });
}

export async function setStats(stats: ImpactStats): Promise<void> {
  const docRef = doc(db, STATS_DOC);
  await setDoc(docRef, sanitizeFirestoreData(stats), { merge: true });
}
